import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiBaseResponse, CommonDropdown } from '../models';
import { map } from 'rxjs/operators';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class AuctionSurveyService {
  constructor(private http: HttpClient) {}

  getSurveyOptionsListing(): Observable<CommonDropdown[]> {
    return this.http
      .get<ApiBaseResponse<CommonDropdown[]>>(
        `${environment.apiUrl}/auctionSurvey`
      )
      .pipe(map((it) => it.data));
  }

  saveAuctionSurvey(auctionId: number, options: string): Observable<any> {
    return this.http
      .post<ApiBaseResponse<any>>(`${environment.apiUrl}/auctionSurvey`, {
        auctionId: auctionId,
        selectedOptions: options,
      })
      .pipe(map((it) => it.data));
  }
}
